import {
  CheckIcon,
  HandThumbUpIcon,
  XMarkIcon,
  ExclamationTriangleIcon,
  ClockIcon,
} from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TransactionHistory({ transactions }) {
  const attempts = transactions?.paymentAttempts ?? [];
  if (!attempts.length) {
    return <p className="text-xs text-gray-400">No previous payment attempts.</p>;
  }

  const events = attempts.map((att, index) => {
    const created = new Date(att.createdDate);
    const result = (att.result ?? "").toString().toUpperCase();

    let title;
    let icon;
    let iconBackground;

    switch (result) {
      case "CAPTURED":
        title = "Payment captured";
        icon = CheckIcon;
        iconBackground = "bg-green-500";
        break;

      case "FAILED":
        title = "Payment failed";
        icon = XMarkIcon;
        iconBackground = "bg-red-500";
        break;

      case "DECLINED":
        title = "Payment declined";
        icon = XMarkIcon;
        iconBackground = "bg-red-500";
        break;

      case "CANCELLED":
        title = "Payment cancelled";
        icon = ExclamationTriangleIcon;
        iconBackground = "bg-gray-400";
        break;

      case "ABANDONED":
        title = "Payment abandoned";
        icon = ExclamationTriangleIcon;
        iconBackground = "bg-amber-500";
        break;

      case "TIMEDOUT":
      case "TIMED_OUT":
        title = "Payment timed out";
        icon = ClockIcon;
        iconBackground = "bg-amber-500";
        break;

      case "NULL":
      default:
        title = "Payment initiated";
        icon = HandThumbUpIcon;
        iconBackground = "bg-blue-500";
        break;
    }

    // if you still want isSuccess to override, you can do it here:
    if (att.isSuccess && result !== "CAPTURED") {
      title = "Payment captured";
      icon = CheckIcon;
      iconBackground = "bg-green-500";
    }

    return {
      id: att.id ?? index,
      title,
      gateway: att.gateway ?? "Unknown",
      date: created.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
      datetime: att.createdDate,
      icon,
      iconBackground,
    };
  });

  return (
    <ul className="space-y-3">
      {events.map((event) => (
        <li key={event.id} className="flex items-start gap-3">
          <span
            className={classNames(
              event.iconBackground,
              "mt-0.5 flex h-8 w-8 items-center justify-center rounded-full"
            )}
          >
            <event.icon className="h-5 w-5 text-white" aria-hidden="true" />
          </span>

          <div className="flex flex-1 items-start justify-between gap-3">
            <div className="space-y-0.5">
              <p className="text-sm text-gray-700">
                <span className="font-medium">{event.title}</span>{" "}
                <span className={`text-gray-500 ${event.gateway == '' ? 'hidden' : event.gateway == null ? 'hidden' : event.gateway == undefined ? 'hidden' : ''}`}>via</span>{" "}
                <span className="font-semibold text-gray-900 uppercase">
                  {event.gateway}
                </span>
              </p>
            </div>
            <div className="text-xs text-gray-500 text-right">
              <time dateTime={event.datetime}>{event.date}</time>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
